interface LogoProps {
  size?: number
  variant?: 'full' | 'mark'
  theme?: 'light' | 'dark'
}

export function Logo({ size = 32, variant = 'full', theme = 'dark' }: LogoProps) {
  const textColor = theme === 'dark' ? '#ffffff' : '#1e1b4b'
  const subColor = theme === 'dark' ? '#a5b4fc' : '#6366f1'

  const mark = (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="10" fill="#4F46E5" />
      {/* Document shape */}
      <rect x="10" y="8" width="16" height="20" rx="2" fill="white" opacity="0.2" />
      <rect x="10" y="8" width="14" height="18" rx="2" fill="white" opacity="0.9" />
      {/* Lines on document */}
      <rect x="13" y="13" width="8" height="1.5" rx="0.75" fill="#4F46E5" opacity="0.5" />
      <rect x="13" y="16" width="6" height="1.5" rx="0.75" fill="#4F46E5" opacity="0.5" />
      {/* Check badge */}
      <circle cx="26" cy="26" r="8" fill="#4F46E5" />
      <circle cx="26" cy="26" r="7" fill="#22c55e" />
      <path d="M22.5 26L25 28.5L30 23" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )

  if (variant === 'mark') return mark

  return (
    <div className="flex items-center gap-2.5">
      {mark}
      <div className="flex flex-col leading-none">
        <span style={{ color: textColor, fontSize: size * 0.5, fontWeight: 700, letterSpacing: '-0.02em', lineHeight: 1.1 }}>
          Cert<span style={{ color: subColor }}>Slate</span>
        </span>
      </div>
    </div>
  )
}
